import { render, staticRenderFns } from "./EntityAddressCreate.vue?vue&type=template&id=57b13012"
import script from "./EntityAddressCreate.vue?vue&type=script&lang=js"
export * from "./EntityAddressCreate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports